import useTheme from "hooks/useTheme";

const ComingSoon = () => {
	const { appLanguage, themeColor } = useTheme();

	return (
		<div className="flex flex-col w-full items-center justify-start col-span-2 py-2 px-3 space-y-4">
			<div className="flex w-full items-center justify-center">
				<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.comingSoon}</p>
			</div>

			<div className="flex flex-col w-full items-center justify-center">
				<p
					className={`text-sm text-center ${themeColor?.text}`}
					dangerouslySetInnerHTML={{ __html: appLanguage?.comingSoonPageContent }}
				/>
			</div>
		</div>
	);
};

export default ComingSoon;
